const SectionContainer = ({ styleSection, styleContainer, children }) => {
  return (
    <section className={styleSection}>
      <div className={`container mx-auto ${styleContainer}`}>{children}</div>
    </section>
  );
};

export default SectionContainer;
